import React from 'react';

/**
 * Context is created here to pass system prop padding
 * to Panel.Header and Panel.Section
 */
export const PanelPaddingContext = React.createContext({});
